import moment from 'moment';

const formatDate = (string, format) => {
  return string ? moment(string).format(format) : '';
};

export default formatDate;
